export default "__VITE_ASSET__umHBbWZ2__"